module.exports = __webpack_public_path__ + "static/media/empty-clients.a0fb2970.svg";